<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import type {IProduct} from "../../interfaces/product.interface";
    import {createEventDispatcher} from "svelte";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let products: Array<IProduct> = [];
    export let loadingProducts: boolean = false;
    let dispatch = createEventDispatcher();
    let searchText: string;
    let timer;
    let open = false;

    export function setOpen(value: boolean) {
        open = value;
    }

    function closeProducts() {
        products = [];
        searchText = '';
        loadingProducts = false;
        dispatch('close');
    }

    function onFilter() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            filterProducts()
        }, 300);
    }

    function filterProducts() {
        loadingProducts = true;
        products = [];
        dispatch('filterProducts', {
            term: searchText
        });
    }

    function handleChange(product: IProduct) {
        if (product.selected) {
            products.forEach((p: IProduct) => {
                p.selected = p.id === product.id;
            });
            products = [...products];
        }
    }

    function setProductToItem() {
        const find = products.find(p => p.selected);
        dispatch('setProduct', {
            product: find ? find.id : null
        });
        products.forEach(p => {
            p.selected = false;
            p.hidden = false;
        });
        products = [...products];
        searchText = '';
        open = false;
    }
</script>

<NauiSlideOver bind:open={open}
               maxWidth="300px"
               on:close={closeProducts}
               title="Buscar código">
    <div class="flex-col">
        <div class="relative">
            <input type="text"
                   bind:value={searchText}
                   on:input={onFilter}
                   class="w-100 search"
                   placeholder="Buscar por código o descripción">
            <i class="fa fa-search primary"></i>
        </div>
        <div class="flex-100 mt-1" style="max-width: 400px">
            {#if loadingProducts}
                <div class="text-c">
                    <div>
                        <i class="fal fa-spinner-third fa-spin"></i>
                    </div>
                    <div>
                        <small>Buscando...</small>
                    </div>
                </div>
            {/if}
            {#each products as product}
                {#if !product.hidden}
                    <NauiCheckbox label={product.label}
                                  on:change={()=>handleChange(product)}
                                  bind:value={product.selected}/>
                {/if}
            {/each}
        </div>
    </div>
    <div slot="actions" class="box w-100">
        <NauiButton caption="AÑADIR CÓDIGO"
                    color="accent"
                    mode="outline"
                    className="min-w-300px"
                    on:click={setProductToItem}/>
    </div>
</NauiSlideOver>

<style>
    .search {
        border-radius: 3rem;
        padding-left: 2.5rem;
    }

    .search + i {
        position: absolute;
        left: .75rem;
        top: .75rem;
    }
</style>